
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Audio extends Vue {
    @Prop({ required: true }) private url!: string;
    @Prop({ default: "" }) private duration!: string;
    @Prop({ default: true }) private showClose!: boolean;

    private showAnimation: boolean = false;
    private isPlaying: boolean = false;
    private audioSrc: string = "";

    mounted() {
        this.$nextTick(() => {
            (this as any).$refs.audioRef.addEventListener("ended", () => {
                this.showAnimation = false;
                this.isPlaying = false;
            });
        });
    }

    private delAudio() {
        this.$emit("delAudio");
    }

    // 播放音频
    private playAudio() {
        this.isPlaying = !this.isPlaying;

        if (this.isPlaying) {
            this.audioSrc = this.url;
            this.showAnimation = true;
            this.$nextTick(() => {
                (this as any).$refs.audioRef.play();
            });
        } else {
            this.showAnimation = false;
            this.audioSrc = "";
        }
    }
}
